"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames6 = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Button = _interopRequireDefault(require("../Button"));
var _Form = _interopRequireDefault(require("../Form"));
var _keys = require("../utils/keys");
var _regex = require("../utils/regex");
var _excluded = ["rowsPerPage", "data", "cols", "sortBy", "totalRowCount", "handleCurrentPageChange", "shouldUseCustomPagination", "getAriaLabel"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* babel-plugin-inline-import './icon-arrow-down.svg' */
var DownArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTQuNjA4IDQuNjA0YS42MTEuNjExIDAgMDEtLjQzOC0uMTgxTC44NDQgMS4wOTZBLjYxNy42MTcgMCAwMS44NC4yMzNhLjYwOC42MDggMCAwMS44NjQuMDAzTDQuNjQ5IDMuMTggNy42NC4yOTRBLjYxNy42MTcgMCAwMTguNS4zMDdhLjYwOC42MDggMCAwMS0uMDE3Ljg2M0w1LjEgNC40MzdhLjYxMi42MTIgMCAwMS0uNDkyLjE2N3oiIGlkPSJhIi8+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC4zMzMgMSkiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PGcgbWFzaz0idXJsKCNiKSIgZmlsbD0iIzAwODU2ZiI+PHBhdGggZD0iTS0zLjMzMy02aDE2djE2aC0xNnoiLz48L2c+PC9nPjwvc3ZnPg==";
/* babel-plugin-inline-import './icon-arrow-up.svg' */
var UpArrow = "data:image/svg+xml;base64,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";
/* babel-plugin-inline-import './icon-arrow-left.svg' */
var LeftArrow = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48cGF0aCBkPSJNLjAwOCA0Ljg5NWEuNzQzLjc0MyAwIDAxLjIzOC0uNTEyTDQuNjI0LjIzMUEuODIzLjgyMyAwIDAxNS4yIDBjLjQ0IDAgLjguMzQyLjguNzU5YS43NDIuNzQyIDAgMDEtLjI0NC41NDdMMS44ODIgNC45OGwzLjc5OSAzLjczYS43NDEuNzQxIDAgMDEuMjI0LjUzYzAgLjQxNi0uMzYxLjc2LS44Ljc2YS44MjMuODIzIDAgMDEtLjU3Ny0uMjMzbC00LjMtNC4yMjRhLjczOS43MzkgMCAwMS0uMjE5LS42NXoiIGZpbGw9IiM5NTlkYTciLz48L3N2Zz4=";
/* babel-plugin-inline-import './icon-arrow-right.svg' */
var RightArrow = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48cGF0aCBkPSJNNS45OTIgNC44OTVhLjc0My43NDMgMCAwMC0uMjM4LS41MTJMMS4zNzYuMjMxQS44MjMuODIzIDAgMDAuOCAwYy0uNDQgMC0uOC4zNDItLjguNzU5IDAgLjIwNi4wODguNDAzLjI0NC41NDdMNC4xMTggNC45OC4zMiA4LjcxMWEuNzQxLjc0MSAwIDAwLS4yMjQuNTNjMCAuNDE2LjM2MS43Ni44Ljc2YS44MjMuODIzIDAgMDAuNTc3LS4yMzNsNC4zLTQuMjI0YS43MzkuNzM5IDAgMDAuMjE5LS42NXoiIGZpbGw9IiM5NTlkYTciLz48L3N2Zz4=";
var Table = function Table(_ref) {
  var _classnames2, _classnames5;
  var _ref$rowsPerPage = _ref.rowsPerPage,
    rowsPerPage = _ref$rowsPerPage === void 0 ? 1000 : _ref$rowsPerPage,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    _ref$cols = _ref.cols,
    cols = _ref$cols === void 0 ? [] : _ref$cols,
    _ref$sortBy = _ref.sortBy,
    sortBy = _ref$sortBy === void 0 ? 'ascending' : _ref$sortBy,
    totalRowCount = _ref.totalRowCount,
    handleCurrentPageChange = _ref.handleCurrentPageChange,
    shouldUseCustomPagination = _ref.shouldUseCustomPagination,
    getAriaLabel = _ref.getAriaLabel,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(props.sort || ''),
    _useState2 = _slicedToArray(_useState, 2),
    sortState = _useState2[0],
    setSortState = _useState2[1];
  var _useState3 = (0, _react.useState)(sortBy === 'ascending'),
    _useState4 = _slicedToArray(_useState3, 2),
    ascending = _useState4[0],
    setAscending = _useState4[1];
  var _useState5 = (0, _react.useState)(props.currentPage || 1),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPage = _useState6[0],
    setCurrentPage = _useState6[1];
  var _useState7 = (0, _react.useState)('1'),
    _useState8 = _slicedToArray(_useState7, 2),
    pageInput = _useState8[0],
    setPageInput = _useState8[1];
  (0, _react.useEffect)(function () {
    if (handleCurrentPageChange) handleCurrentPageChange(currentPage);
  }, [currentPage]);
  (0, _react.useEffect)(function () {
    if (props.pagination || props.resetPagination) setCurrentPage(props.currentPage || 1);
  }, [props.pagination, props.resetPagination]);
  var isEmptyValue = function isEmptyValue(val) {
    //Empty values go to the bottom on sort
    return val === undefined || val === null || val === '';
  };
  var getValue = function getValue(obj, name) {
    if (name === '*') return obj;
    var parts = name.split('.');
    if (parts.length === 1) return obj[parts[0]];
    if (!obj[parts[0]]) return null;
    return getValue(obj[parts[0]], parts.slice(1).join('.'));
  };
  var formatSortValue = function formatSortValue(value, col) {
    if (col !== null && col !== void 0 && col.isDate) return new Date(value).getTime();
    if (typeof value === 'string') {
      var _value$match$, _value$match;
      if (col !== null && col !== void 0 && col.isNumber) return parseFloat((_value$match$ = (_value$match = value.match(_regex.matchFloatInString)) === null || _value$match === void 0 ? void 0 : _value$match[0]) !== null && _value$match$ !== void 0 ? _value$match$ : '');
      return value.toLowerCase();
    }
    if (value === undefined) return col === null || col === void 0 ? void 0 : col.defaultValue;
    return value;
  };
  var tableSort = (0, _react.useMemo)(function () {
    if (props.noSort) return data;
    if (!data) return [];
    var col = cols.find(function (c) {
      return c.name === sortState || c.sortField === sortState;
    }) || {
      isDate: false,
      defaultValue: undefined,
      isNumber: false
    };
    return data.sort(function (a, b) {
      var aValue = formatSortValue(getValue(a, sortState), col);
      var bValue = formatSortValue(getValue(b, sortState), col);
      var sort;
      if (isEmptyValue(aValue)) {
        sort = 1;
      } else if (isEmptyValue(bValue)) {
        sort = -1;
      } else {
        sort = aValue > bValue ? 1 : -1;
      }
      return ascending ? sort : sort * -1;
    });
  }, [data, sortState, ascending, props.noSort]);
  var onSort = function onSort(name) {
    if (sortState === name) setAscending(!ascending);else {
      setAscending(!ascending);
      setSortState(name);
    }
  };
  var isSorted = function isSorted(name) {
    return sortState === name;
  };
  var getNumberOfPages = function getNumberOfPages() {
    if (!data) return 1;
    var totalRows = totalRowCount || data.length;
    var pagesCount = Math.ceil(totalRows / rowsPerPage);
    return pagesCount || 1;
  };
  (0, _react.useEffect)(function () {
    var numberOfPages = getNumberOfPages();
    if (currentPage < numberOfPages) return;
    setCurrentPage(numberOfPages);
  }, [data.length]);
  var onPrevPage = function onPrevPage() {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  var onNextPage = function onNextPage() {
    if (currentPage < getNumberOfPages()) setCurrentPage(currentPage + 1);
  };
  var onPaginationSubmit = function onPaginationSubmit() {
    if (!pageInput) return;
    setCurrentPage(parseInt(pageInput.toString()));
  };
  var onPaginationChange = function onPaginationChange(v) {
    var val = v.target.value;
    if (!val) {
      setPageInput('');
      return;
    }
    if (!/^[0-9]*$/g.test(val)) return;
    var parsed = parseInt(val);
    if (!isNaN(parsed)) {
      if (parsed > 0 && parsed <= getNumberOfPages()) setPageInput(val);else return;
    }
  };
  var arrow = function arrow(dir) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Array(n).fill(null).map(function (_, i) {
      return /*#__PURE__*/_react.default.createElement("img", {
        key: i,
        src: dir === 'l' ? LeftArrow : RightArrow,
        height: 8,
        alt: "".concat(dir === 'l' ? 'Left' : 'Right', " arrow")
      });
    });
  };
  var handleKeyDown = function handleKeyDown(e, callback) {
    if (_keys.SUBMIT_KEYS.has(e.key)) {
      callback();
    }
  };
  var handleColumnClick = function handleColumnClick(col, colFieldName) {
    var columnName = col.sortField || colFieldName;
    if (!col.sort) return;
    onSort(columnName);
    props.handleColumnClick && props.handleColumnClick(columnName, ascending);
  };
  var handleRowClick = function handleRowClick(row, i) {
    if (props.selectable) {
      var _props$onSelect;
      (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, row, i);
    }
  };
  var renderTableHeader = function renderTableHeader() {
    return /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, cols.map(function (col) {
      var colClasses = (0, _classnames6.default)(_defineProperty({
        'sa-has-sort': col.sort,
        'sa-col-center': col.position === 'center',
        'sa-col-right': col.position === 'right'
      }, col.className || '', !!col.className));
      var colFieldName = col.value || col.path || col.name;
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        key: col.key || colFieldName,
        text: col.tooltip
      }, /*#__PURE__*/_react.default.createElement("th", {
        className: colClasses,
        tabIndex: 0,
        onClick: function onClick() {
          return handleColumnClick(col, colFieldName);
        },
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, function () {
            return handleColumnClick(col, colFieldName);
          });
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, col.renderTitle ? col.renderTitle(col.name, col.data) : col.name), isSorted(col.sortField || colFieldName) ? /*#__PURE__*/_react.default.createElement("span", {
        className: "sa-sort-arrow"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "sorted by",
        src: ascending ? UpArrow : DownArrow
      })) : null));
    })));
  };

  //props.currentPage is used for custom pagination using backend
  //min value will be 0 if props.currentPage is passed coz on each page change, comes new data from backend
  var min = shouldUseCustomPagination ? 0 : (currentPage - 1) * rowsPerPage;
  var max = rowsPerPage + (min - 1);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, data.length !== 0 ? /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames6.default)((_classnames2 = {
      'sa-table': true
    }, _defineProperty(_classnames2, props.className, !!props.className), _defineProperty(_classnames2, 'sa-fixed-cols', props.fixedCols), _classnames2))
  }, props.caption ? /*#__PURE__*/_react.default.createElement("caption", {
    className: "accessibility-hidden"
  }, props.caption) : null, props.noHeader ? null : renderTableHeader(), /*#__PURE__*/_react.default.createElement("tbody", null, tableSort.filter(function (row) {
    return !!row;
  }).map(function (row, i1) {
    var _props$isRowSelected;
    var rowSelected = (_props$isRowSelected = props.isRowSelected) === null || _props$isRowSelected === void 0 ? void 0 : _props$isRowSelected.call(props, row, i1);
    var rowClass = (0, _classnames6.default)(_defineProperty({
      'sa-row-select': props.selectable,
      'sa-row-selected': rowSelected
    }, row.className, !!row.className));
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "".concat(row.ID || row[props.columnid], "-").concat(i1),
      tabIndex: props.selectable ? 0 : -1,
      "aria-label": getAriaLabel === null || getAriaLabel === void 0 ? void 0 : getAriaLabel(row, i1),
      "aria-selected": rowSelected,
      className: rowClass,
      onClick: function onClick() {
        return handleRowClick(row, i1);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, function () {
          return handleRowClick(row, i1);
        });
      }
    }, cols.map(function (col, i2) {
      var _getValue;
      var colClasses = (0, _classnames6.default)(_defineProperty({
        'sa-row-title': col.title,
        'sa-col-center': col.position === 'center',
        'sa-col-right': col.position === 'right',
        'sa-col-fixed-width': col.fixedWidth
      }, col.className || '', !!col.className));
      var value = (_getValue = getValue(row, col.value || col.path || col.name)) !== null && _getValue !== void 0 ? _getValue : col.defaultValue;
      var renderedValue = col.render ? col.render(value) : value;
      return /*#__PURE__*/_react.default.createElement("td", {
        key: "".concat(col.name, "-").concat(i2),
        className: colClasses
      }, col.clipFieldValues ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        text: renderedValue
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-col-clipped-width-field",
        "data-testid": "clipped-field"
      }, renderedValue)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderedValue));
    }));
  }).slice(min, max + 1)), props.footer ? /*#__PURE__*/_react.default.createElement("tfoot", null, props.footer) : null) : props.noDataShowHeaders ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames6.default)((_classnames5 = {
      'sa-table': true
    }, _defineProperty(_classnames5, props.className, !!props.className), _defineProperty(_classnames5, 'sa-fixed-cols', props.fixedCols), _classnames5))
  }, props.caption ? /*#__PURE__*/_react.default.createElement("caption", {
    className: "accessibility-hidden"
  }, props.caption) : null, renderTableHeader()), /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-table no-data"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-no-table-data"
  }, props.noData === undefined ? "No data available" : props.noData))) : props.noData !== null && /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-table no-data"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-no-table-data"
  }, props.noData === undefined ? "No data available" : props.noData)), props.pagination && getNumberOfPages() > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-pagination"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sa-pagination-relative"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    title: "First page",
    onClick: function onClick() {
      return setCurrentPage(1);
    }
  }, arrow('l', 2)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    title: "Previous page",
    onClick: onPrevPage
  }, arrow('l')), /*#__PURE__*/_react.default.createElement("div", null, "".concat(currentPage, " of ").concat(getNumberOfPages())), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    title: "Next page",
    onClick: onNextPage
  }, arrow('r')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    title: "Last page",
    onClick: function onClick() {
      return setCurrentPage(getNumberOfPages());
    }
  }, arrow('r', 2))), /*#__PURE__*/_react.default.createElement(_Form.default, {
    "aria-label": "Change the current page number",
    onSubmit: onPaginationSubmit,
    className: "sa-pagination-absolute"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "pageNumber"
  }, "Go to page"), /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    id: "pageNumber",
    name: "pageNumber",
    className: "sa-pagination-absolute-selector",
    value: pageInput.toString(),
    style: {
      width: "".concat(pageInput.toString().length, "ch")
    },
    onChange: onPaginationChange
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: !pageInput,
    title: "Submit the new page number",
    className: "sa-pagination-absolute-go"
  }, "Go"))));
};
var _default = Table;
exports.default = _default;